import { gatewayInstance } from "../../axiosInstance";

export const filterOracleProcessQueue = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/integrationservice/oracle-process-queue/filter-list`,
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const immediateOracleIntegration = async (data) => {
  try {
    const response = await gatewayInstance.get(
      `/integrationservice/oracle-process-queue/immediate-integration`,
      {
        params: {
          processType: data.processType,
          evinvOrCreditdebitNumber: data.code,
        },
      }
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};
